import React from "react";
import { useIntl } from "react-intl";
import { Box, InputAdornment } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import { IconButton } from "../button/Buttons.js";
import "../button/EditButton.js";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
import { localizedAutocomplete } from "./Autocomplete.localize.js";
import { useAutocompleteClasses } from "./Autocomplete.styles.js";
const AutocompleteInput = ({ params, placeholder, loading, multiple, inputValue, onClear, startIcon }) => {
  const { formatMessage } = useIntl();
  const { classes: styles } = useAutocompleteClasses();
  return /* @__PURE__ */ React.createElement(
    TextField,
    {
      ...params,
      ref: params.InputProps.ref,
      placeholder: placeholder ? formatMessage(placeholder) : formatMessage(localizedAutocomplete.autocompletePlaceholder),
      multiline: multiple,
      slotProps: {
        input: {
          inputProps: { "data-testid": "autocompleteInput", ...params.inputProps, value: inputValue },
          ...params.InputProps,
          startAdornment: startIcon ? /* @__PURE__ */ React.createElement(Box, { className: styles.autocompleteStartAdornment }, startIcon) : params.InputProps.startAdornment,
          endAdornment: /* @__PURE__ */ React.createElement(React.Fragment, null, loading ? /* @__PURE__ */ React.createElement(Box, { className: styles.autocompleteCircularProgress }, /* @__PURE__ */ React.createElement(CircularProgress, { size: 12 })) : inputValue && !multiple ? /* @__PURE__ */ React.createElement(InputAdornment, { position: "end" }, /* @__PURE__ */ React.createElement(IconButton, { onClick: onClear, edge: "end", size: "small", "data-testid": "clearButton" }, /* @__PURE__ */ React.createElement(Box, { component: "span", className: CustomIcon.CancelOutline, fontSize: 8 }))) : null, multiple ? params?.InputProps.endAdornment : null),
          disableUnderline: true
        }
      }
    }
  );
};
const renderInput = (multiple, params, placeholder, loading, inputValue, onClear, startIcon) => {
  return /* @__PURE__ */ React.createElement(
    AutocompleteInput,
    {
      multiple,
      params,
      placeholder,
      loading,
      inputValue,
      onClear,
      startIcon
    }
  );
};
export {
  AutocompleteInput,
  renderInput
};
//# sourceMappingURL=AutocompleteInput.js.map
